export default __webpack_public_path__ + "static/media/pytorch.4db22492.png";